export default () => {
  const tabbarButtons = document.querySelectorAll('.tab');
  const tabbarContents = document.querySelectorAll('.tab-content');

  tabbarButtons.forEach((tabBtn, key) => {
    tabBtn.addEventListener('click', () => {
      tabBtn.classList.toggle('active');

      tabbarButtons.forEach(function(ell, els){
        if(key !== els) {
            ell.classList.remove('active');
        }
      });

      tabbarContents.forEach(tabCnt => {
        if (tabCnt.dataset.tab === tabBtn.dataset.tab) {
          tabCnt.classList.add('active');
        } else {
          tabCnt.classList.remove('active');
        }
      })
    });
  })

  $('.tab-content').on('click', function(){

    $('.tab-content').removeClass('clicked');
    $(this).addClass('clicked');

    if($('.map-wrapper').length > 0){
      let scroll = $('.map-wrapper').offset().top - $('.header').height();

      $('html,body').animate({scrollTop: scroll},'slow');
    }

    return false;
  });
}



// WEBPACK FOOTER //
// ./scripts/layouts/location.js